import { render, staticRenderFns } from "./JobGradeCards.vue?vue&type=template&id=06c0c95e&"
import script from "./JobGradeCards.vue?vue&type=script&lang=js&"
export * from "./JobGradeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports